<template>
    <div class="p-fluid formgrid grid mt-10">
        <div class="field">Where to place this new employee ?</div>
        <div class="field col-12">
            <label for="placement">Placement</label>
            <Dropdown :class="{'p-invalid' : submitted && !form.placement_id }"
                    v-model="form.placement_id"
                    :options="placements"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Placement" required="true"/>
            <small class="p-invalid" v-if="submitted && !form.placement_id"
                >Placement is required.</small
            >
        </div>
        <div class="field col-12">
            <label for="placement">Division</label>
            <Dropdown :class="{'p-invalid' : submitted && !form.division_id }"
                    v-model="form.division_id"
                    :options="divisions"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Division" required="true"/>
            <small class="p-invalid" v-if="submitted && !form.division_id"
                >Division is required.</small
            >
        </div>
        <div class="field col-12">
            <label for="placement">Team</label>
            <Dropdown
                    :class="{'p-invalid' : submitted && !form.team_id }"
                    v-model="form.team_id"
                    :options="teams"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Team" required="true"/>
            <small class="p-invalid" v-if="submitted && !form.team_id">
                Team is required.
            </small>
        </div>
        <div class="field col-12">
            <label for="placement">Position</label>
            <Dropdown
                    :class="{'p-invalid' : submitted && !form.position_id }"
                    v-model="form.position_id"
                    :options="positions"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Position" required="true" />
            <small class="p-invalid" v-if="submitted && !form.position_id">
                Position is required.
            </small>
        </div>
    </div>
</template>

<script>
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import axios from "axios";

export default {
    components: {InputText, Dropdown, Button},
    props: ['models'],
    data(){
        return{
            showDialog: this.status,
            placements: [],
            divisions: [],
            teams: [],
            positions: [],
            datatableService: '',
            form:{},
            submitted: false,
        }
    },
    mounted(){
        this.loadData();
    },
    methods:{
        loadData(){
            axios.get(`${this.$page.props.appUrl}api/placement-units`)
            .then((data)=>{
                this.placements = data.data;
            });
            axios.get(`${this.$page.props.appUrl}api/divisions`)
            .then((data)=>{
                this.divisions = data.data;
            });
            axios.get(`${this.$page.props.appUrl}api/teams`)
            .then((data)=>{
                this.teams = data.data;
            });
            axios.get(`${this.$page.props.appUrl}api/positions`)
            .then((data)=>{
                this.positions = data.data;
            });
        }
    },
}
</script>
